var map = {
	"./may_1.jpg": 9941,
	"./may_10.jpg": 233,
	"./may_2.jpg": 5738,
	"./may_3.jpg": 6903,
	"./may_4.jpg": 6940,
	"./may_5.jpg": 2201,
	"./may_6.jpg": 2606,
	"./may_7.jpg": 7563,
	"./may_8.jpg": 4784,
	"./may_9.jpg": 349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4953;